/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 10:52:22
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/zushou/list",
      method: "get",
      params: query
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/zushou/detail",
      method: "post",
      params: query
    });
  },
  // 标记成交
  sale(query) {
    return request({
      url: "/zushou/sale",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(query) {
    return request({
      url: "/zushou/remove",
      method: "post",
      params: query
    });
  },
  // 删除
  edit(query) {
    return request({
      url: "/zushou/edit",
      method: "post",
      params: query
    });
  },
  // 待审核列表
  reviewList(query) {
    return request({
      url: "/zushou/reviewList",
      method: "get",
      params: query
    });
  },
  // 审核
  review(query) {
    return request({
      url: "/zushou/review",
      method: "post",
      params: query
    });
  },
  // banner列表
  banner(query) {
    return request({
      url: "/zushou/banner",
      method: "get",
      params: query
    });
  },
  // 审核
  create(query) {
    return request({
      url: "/zushou/create",
      method: "post",
      params: query
    });
  },
  // 导出
  exportData(query) {
    return request({
      url: "/zushou/exportData",
      method: "post",
      params: query
    });
  },
};
export default index;